// extracted by mini-css-extract-plugin
module.exports = {"Submitted":"Submitted__Submitted___pe_UP","Container":"Submitted__Container___1UlM9","OrderProgress":"Submitted__OrderProgress___1u5om"};